/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { InputPlayerStatsModel, InputPlayerStatsModelType } from './InputPlayerStatsModel'
import { InputPlayerStatsModelSelector } from './InputPlayerStatsModel.base'
import { RootStoreType } from './index'

/**
 * GameStatsBase
 * auto generated base class for the model GameStatsModel.
 */
export const GameStatsModelBase = ModelBase.named('GameStats')
  .props({
    __typename: types.optional(types.literal('GameStats'), 'GameStats'),
    isGameRunning: types.union(types.undefined, types.boolean),
    kind: types.union(types.undefined, types.string),
    players: types.union(types.undefined, types.array(types.late(() => InputPlayerStatsModel))),
    prizePool: types.union(types.undefined, types.number),
    runTime: types.union(types.undefined, types.string),
    winners: types.union(types.undefined, types.frozen())
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class GameStatsModelSelector extends QueryBuilder {
  get isGameRunning() {
    return this.__attr('isGameRunning')
  }
  get kind() {
    return this.__attr('kind')
  }
  get prizePool() {
    return this.__attr('prizePool')
  }
  get runTime() {
    return this.__attr('runTime')
  }
  get winners() {
    return this.__attr('winners')
  }
  players(
    builder:
      | string
      | InputPlayerStatsModelSelector
      | ((selector: InputPlayerStatsModelSelector) => InputPlayerStatsModelSelector)
      | undefined
  ) {
    return this.__child('players', InputPlayerStatsModelSelector, builder)
  }
}
export function selectFromGameStats() {
  return new GameStatsModelSelector()
}

export const gameStatsModelPrimitives = selectFromGameStats().isGameRunning.kind.prizePool.runTime.winners
